/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.BusinessTypesResponse, () => void, () => void];

function useFetchBusinessTypes({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [response, setResponse] = useState<vp.BusinessTypesResponse>({
    Success: false,
    ErrorMessage: '',
    BusinessTypes: {},
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async () => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');

      const res = await api.fetchBusinessTypes(source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (shouldSendRequest) void sendRequest();

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    () => {
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        BusinessTypes: {},
      });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchBusinessTypes);
